class TabAccordion {
  constructor(el) {
    this.$el = $(el);
    this.$tabBtns = this.$el.find('.tab-accordion__tab-btn');
    this.$accordionBtns = this.$el.find('.tab-accordion__accordion-btn');
    this.$panels = this.$el.find('.tab-accordion__panel');
    this.isMobile = window.innerWidth < 992;
    this.animationSpeed = 300;
    this.hashInUrl = window.location.hash;
    this.ariaSelected = 'aria-selected';
    this.ariaExpanded = 'aria-expanded';
    this.tabAccordionContent = '.tab-accordion__content';
  }

  init() {
    this.setupInitialState();
    this.bindEvents();

    // Check for hash in URL and activate corresponding tab
    if (this.hashInUrl && this.hasMatchingPanel()) {
      this.activateTabFromHash();

      // Scroll to the module after a short delay to ensure everything is rendered
      setTimeout(() => {
        this.scrollToModule();
      }, 100);
    }

    $(window).on('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 992;

      if (wasMobile !== this.isMobile) {
        this.resetActiveState();
      }
    });

    // Listen for hashchange events
    $(window).on('hashchange', () => {
      this.hashInUrl = window.location.hash;

      // Only activate and scroll if the hash matches a panel in this module
      if (this.hasMatchingPanel()) {
        this.activateTabFromHash();
        this.scrollToModule();
      }
    });
  }

  hasMatchingPanel() {
    const hash = this.hashInUrl.substring(1);
    if (!hash) {
      return false;
    }

    // Check if any panel in this module has a matching data-id
    return this.$panels.filter(`[data-id="${hash}"]`).length > 0;
  }

  scrollToModule() {
    const hash = this.hashInUrl.substring(1);
    if (!hash) {
      return;
    }

    const $targetPanel = this.$panels.filter(`[data-id="${hash}"]`);
    if ($targetPanel.length) {
      // Calculate header height (assuming a fixed header of 100px, adjust as needed)
      const headerHeight = $('.header').outerHeight() || 100;
      // Scroll to the module
      $('html, body').stop().animate({
        scrollTop: this.$el.offset().top - headerHeight - 100,
      }, 500);
    }
  }

  activateTabFromHash() {
    const hash = this.hashInUrl.substring(1);
    if (!hash) {
      return;
    }

    const $targetPanel = this.$panels.filter(`[data-id="${hash}"]`);
    if ($targetPanel.length) {
      const index = $targetPanel.data('index');

      // For desktop view
      if (!this.isMobile) {
        this.$tabBtns.removeClass('active').attr(this.ariaSelected, 'false');
        this.$tabBtns.eq(index).addClass('active').attr(this.ariaSelected, 'true');

        this.$panels.removeClass('active');
        $targetPanel.addClass('active');

        // Ensure content is visible
        $targetPanel.find(this.tabAccordionContent).show();
      } else {
        // For mobile view
        const $btn = this.$accordionBtns.eq(index);
        const $content = $targetPanel.find(this.tabAccordionContent);

        // Close any open accordion
        const $activeBtn = this.$accordionBtns.filter('.active');
        const $activePanel = this.$panels.filter('.active');

        if ($activeBtn.length && !$btn.hasClass('active')) {
          $activeBtn.removeClass('active').attr(this.ariaExpanded, 'false');
          $activePanel.find(this.tabAccordionContent).slideUp(this.animationSpeed, () => {
            $activePanel.removeClass('active');
          });
        }

        // Open the target accordion
        $btn.addClass('active').attr(this.ariaExpanded, 'true');
        $targetPanel.addClass('active');
        $content.slideDown(this.animationSpeed);
      }

      // Update tab buttons
      this.$tabBtns.removeClass('active').attr(this.ariaSelected, 'false');
      this.$tabBtns.eq(index).addClass('active').attr(this.ariaSelected, 'true');

      // Update accordion buttons
      this.$accordionBtns.removeClass('active').attr(this.ariaExpanded, 'false');
      this.$accordionBtns.eq(index).addClass('active').attr(this.ariaExpanded, 'true');
    }
  }

  setupInitialState() {
    // If we have a hash in the URL, don't set up the default state
    if (this.hashInUrl && this.activateTabFromHash()) {
      return;
    }

    this.$panels.not(':first').each((_, panel) => {
      const $panel = $(panel);
      const $content = $panel.find(this.tabAccordionContent);

      if (this.isMobile) {
        $content.hide();
      } else {
        $panel.removeClass('active');
      }
    });

    const $firstPanel = this.$panels.first();
    $firstPanel.addClass('active');
    $firstPanel.find(this.tabAccordionContent).show();
  }

  resetActiveState() {
    if (this.isMobile) {
      this.$panels.each((_, panel) => {
        const $panel = $(panel);
        const $content = $panel.find(this.tabAccordionContent);
        if (!$panel.hasClass('active')) {
          $content.hide();
        }
      });
    } else {
      this.$panels.not('.active').removeClass('active');
      this.$panels.filter('.active').find(this.tabAccordionContent).show();
    }

    const activeIndex = this.$panels.filter('.active').data('index') || 0;

    this.$tabBtns.removeClass('active').attr(this.ariaSelected, 'false');
    this.$accordionBtns.removeClass('active').attr(this.ariaExpanded, 'false');

    this.$tabBtns.eq(activeIndex).addClass('active').attr(this.ariaSelected, 'true');
    this.$accordionBtns.eq(activeIndex).addClass('active').attr(this.ariaExpanded, 'true');
  }

  bindEvents() {
    this.$tabBtns.on('click', (e) => {
      const $btn = $(e.currentTarget);
      const index = $btn.data('index');
      const $panel = this.$panels.eq(index);
      const panelId = $panel.data('id');

      // Update URL hash without scrolling
      if (panelId) {
        window.history.replaceState(null, null, `#${panelId}`);
      }

      this.$tabBtns.removeClass('active').attr(this.ariaSelected, 'false');
      $btn.addClass('active').attr(this.ariaSelected, 'true');

      this.$accordionBtns.removeClass('active').attr(this.ariaExpanded, 'false');
      this.$accordionBtns.eq(index).addClass('active').attr(this.ariaExpanded, 'true');

      this.$panels.removeClass('active');
      this.$panels.eq(index).addClass('active');

      this.$panels.eq(index).find(this.tabAccordionContent).show();
    });

    this.$accordionBtns.on('click', (e) => {
      if (!this.isMobile) {
        return;
      }

      const $btn = $(e.currentTarget);
      const index = $btn.data('index');
      const $panel = this.$panels.eq(index);
      const $content = $panel.find(this.tabAccordionContent);
      const panelId = $panel.data('id');

      // Update URL hash
      if (panelId) {
        window.history.replaceState(null, null, `#${panelId}`);
      }

      const $activeBtn = this.$accordionBtns.filter('.active');
      const $activePanel = this.$panels.filter('.active');

      if ($activeBtn.length && !$btn.hasClass('active')) {
        $activeBtn.removeClass('active').attr(this.ariaExpanded, 'false');
        $activePanel.find(this.tabAccordionContent).slideUp(this.animationSpeed, () => {
          $activePanel.removeClass('active');
        });
      }

      if (!$btn.hasClass('active')) {
        $btn.addClass('active').attr(this.ariaExpanded, 'true');
        $panel.addClass('active');
        $content.slideDown(this.animationSpeed);

        this.$tabBtns.removeClass('active').attr(this.ariaSelected, 'false');
        this.$tabBtns.eq(index).addClass('active').attr(this.ariaSelected, 'true');
      }
    });
  }
}

export default (() => {
  const $els = $('.tab-accordion');
  $els.each((_, el) => {
    new TabAccordion(el).init();
  });
})();